import { render } from "./WindowMail.vue?vue&type=template&id=4546868a&scoped=true"
import script from "./WindowMail.vue?vue&type=script&lang=js"
export * from "./WindowMail.vue?vue&type=script&lang=js"

import "./WindowMail.vue?vue&type=style&index=0&id=4546868a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4546868a"

export default script